export interface IMarginAllocationV2 {
  balance: {
    value: number;
    formatted: string;
  };
  isTraderShieldEnabled: boolean;
  isPreferencesSaved: boolean;
  accountId: string;
  variation: {
    value: number;
    formatted: string;
    color: string;
  };
  minimumMarginCapital: {
    value: number;
    formatted: string;
  };
  updatedAt: string;
  amountButtons: Array<{
    type: string;
    value: number;
    formatted: string;
  }>;
  availableBalance: IAmountDetails;
  dailyLoss: IAmountDetails;
  allocateButton: {
    disabled: boolean;
    label: string;
    type: string;
  };
  deallocateButton: {
    disabled: boolean;
    label: string;
    type: string;
  } | null;
  recurringLimit: IRecurringLimit;
  traderShieldDetails: ITraderShieldDetails;
  minimumDailyLossPercentage: number;
}

export enum BannerAction {
  GO_TO_AMW_CASH_CLASH = 'go_to_amw_cash_clash'
}

export interface IAmountDetails {
  value: number;
  formatted: string;
  title: string;
  description: string;
  rows: Array<{
    label: string;
    value: string;
  }>;
  banner?: {
    title: string;
    description: string;
    button: {
      label: string;
      action: BannerAction;
    };
  };
}

export interface ITraderShieldDetails {
  title: string;
  subtitle: string;
  description: string;
  rows: Array<{
    title: string;
    subtitle: string;
    icon: string;
  }>;
}

export interface IRecurringLimit {
  title: string;
  description: string;
  details: Array<{
    title: string;
    text: string;
  }>;
}

export interface IMarginAllocationPreviewV2 {
  variationTable: {
    margin: number;
    maxExposeAllowed: number;
    ticker: string;
    unit: string;
    unitSize: number;
    unitValue: number;
  }[];
  termsLink: string;
  policyLink: string;
}
